import {
  NO_PRODUCTS,
  TITLE,
} from 'containers/PLPContainer/translations/constants';

export const plpCommonLocale = {
  [TITLE]: 'Edible Arrangements',
  [NO_PRODUCTS]: ' There are no products. Please try another options.',
};
